import { defineMessage } from 'services/localization';

export const messages = {
    emptyStateTitle: defineMessage('choose_po_to_match_with'),
    emptyStateText: defineMessage('there_are_no_purchase_o__available_for_matching'),
};
